"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delta = exports.DeltaType = void 0;
var DeltaType;
(function (DeltaType) {
    DeltaType["Insert"] = "insert";
    DeltaType["Update"] = "update";
    DeltaType["Delete"] = "delete";
})(DeltaType = exports.DeltaType || (exports.DeltaType = {}));
class Delta {
    constructor(options) {
        this.type = options.type;
        this.path = options.path;
        this.oldValue = options.oldValue;
        this.newValue = options.newValue;
    }
    getPathIndex(keyword) {
        const paths = this.path.split('.');
        for (const path of paths) {
            if (path.includes(keyword)) {
                const matches = path.match(/\[(.*)\]/);
                if (matches && matches.length === 2) {
                    return +matches[1];
                }
            }
        }
        return -1;
    }
}
exports.Delta = Delta;
//# sourceMappingURL=delta.js.map